import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { Flex } from 'foundations-components/components/Flex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { useAssignTask } from 'setup-guide-api/dataFetchingClient/mutations/assignedTasks';
import { deleteTaskAssignment } from 'setup-guide-api/api/assignedTasksApi';
import { captureNetworkError } from 'growth-onboarding-reliability/utils/raven';
import AssignTaskUserSelect from './AssignTaskUserSelect';
import { useTracker } from '../../hooks/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AssignTaskModal = ({
  onClose,
  task,
  assignmentId
}) => {
  const {
    trackSectionView,
    trackUserInteraction
  } = useTracker();
  const {
    assignTask,
    loading
  } = useAssignTask();
  const [selectedTeamMemberId, setSelectedTeamMemberId] = useState(null);
  const createTaskAssignment = async () => {
    if (selectedTeamMemberId) {
      trackUserInteraction('assign task modal assign', task.key, {
        taskId: task.id,
        taskKey: task.key,
        assigneeId: selectedTeamMemberId
      });
      if (assignmentId) {
        await deleteTaskAssignment({
          assignmentId
        });
      }
      await assignTask({
        variables: {
          taskId: task.id,
          userId: selectedTeamMemberId
        }
      });
      onClose();
    }
  };
  const handleAssign = () => {
    createTaskAssignment().catch(captureNetworkError);
  };
  const handleClose = () => {
    trackUserInteraction('assign task modal close', task.key);
    onClose();
  };
  const handleEscape = e => {
    if (e.key === 'Escape') {
      handleClose();
      e.stopPropagation();
      e.preventDefault();
    }
  };
  return /*#__PURE__*/_jsxs(Modal, {
    centered: false,
    onEsc: handleEscape,
    onOpenComplete: () => {
      trackSectionView('assign task modal view', task.key);
    },
    use: "conversational",
    width: 828,
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: handleClose
    }), /*#__PURE__*/_jsx(DialogBody, {
      marginBlockStart: "1000",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "start",
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h1",
          marginBlockEnd: "400",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "setup-guide-components.assignTaskModal.title"
          })
        }), /*#__PURE__*/_jsx(Text, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "setup-guide-components.assignTaskModal.subtitle"
          })
        }), /*#__PURE__*/_jsxs(Flex, {
          inlineSize: "100%",
          justifyContent: "space-between",
          marginBlockStart: "600",
          children: [/*#__PURE__*/_jsxs(Flex, {
            alignItems: "start",
            flexDirection: "column",
            gap: "800",
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h5",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "setup-guide-components.assignTaskModal.taskTitle"
              })
            }), /*#__PURE__*/_jsxs(Flex, {
              alignItems: "end",
              gap: "200",
              marginBlockStart: "100",
              children: [/*#__PURE__*/_jsx(View, {
                inlineSize: "300px",
                maxInlineSize: "300px",
                children: /*#__PURE__*/_jsx(AssignTaskUserSelect, {
                  onTeamMemberSelect: teamMemberId => {
                    setSelectedTeamMemberId(teamMemberId);
                  },
                  selectedTeamMemberId: selectedTeamMemberId,
                  taskId: task.id
                })
              }), /*#__PURE__*/_jsx(View, {
                maxBlockSize: "40px",
                children: /*#__PURE__*/_jsx(LoadingButton, {
                  disabled: !selectedTeamMemberId,
                  loading: loading,
                  onClick: handleAssign,
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "setup-guide-components.assignTaskModal.assignButton"
                  })
                })
              })]
            })]
          }), /*#__PURE__*/_jsx(Illustration, {
            height: 150,
            name: "email-confirmation",
            width: 150
          })]
        })]
      })
    })]
  });
};